import { Button, HeaderTextBlock, LayoutContainer } from '@greystar/designsystem';
import {
  getDictionaryEntry,
  getLinkIcon,
  SEARCHBOX_SUBTITLE_FALLBACK,
  useAnalytics,
} from '@greystar/lib';
import { useI18n } from 'next-localization';
import { useState, JSX } from 'react';
import { SearchBoxSsr } from '../search-box/search-box-ssr';

export const NoSearchResults = (): JSX.Element => {
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const { t } = useI18n();
  const analytics = useAnalytics();

  const openSearchModal = () => {
    const searchTerm =
      document.querySelector<HTMLInputElement>('[data-testid="search-input"]')?.value ?? '';
    const state = searchTerm.includes(',') ? searchTerm.split(',').pop()?.trim() : '';

    const eventData = {
      event: 'property_search_open',
      action_type: 'search model open',
      state: state,
      property_location: '',
      property_id: '',
      property_name: '',
      module_name: 'search results list view',
      inpage_location: 'middle',
      search_term: searchTerm,
      click_text: 'Search for homes',
      click_type: 'internal',
      destination_url: '',
      price_range_filter: '',
      property_type_filter: '',
      property_features_filter: '',
      timeline_filter: '',
    };

    try {
      analytics.trackEvent('property_search_completed', eventData);
    } catch (error) {
      console.error('Analytics tracking failed:', error);
    }

    setIsSearchModalOpen(true);
  };

  const handleModalClick = () => {
    setIsSearchModalOpen(false);
  };

  return (
    <LayoutContainer
      flexDirection="column"
      gap="lg"
      paddingTop="2xl"
      paddingBottom="2xl"
      alignItems="start"
    >
      <HeaderTextBlock>
        <HeaderTextBlock.Subtitle
          subtitle={getDictionaryEntry(
            t('searcharea_nofilterresults'),
            'Try changing or removing some of your filters or adjusting your search area'
          )}
        />
        <HeaderTextBlock.Header
          header={getDictionaryEntry(t('searcharea_noexactmatches'), 'No exact matches')}
        />
      </HeaderTextBlock>
      <Button
        icon={getLinkIcon()}
        label={getDictionaryEntry(t('searchbox_title'), 'Search for homes')}
        variant="primary"
        onClick={openSearchModal}
        data-testid="no-results-search-button"
      />
      {isSearchModalOpen && (
        <SearchBoxSsr
          variant="modal"
          headerTitle={getDictionaryEntry(t('searchbox_title'), 'Search for homes')}
          headerSubtitle={getDictionaryEntry(t('searchbox_subtitle'), SEARCHBOX_SUBTITLE_FALLBACK)}
          onClose={handleModalClick}
          searchPromptText={getDictionaryEntry(t('searchbox_prompttext'), 'Search for homes')}
          searchResultsTitle=""
        />
      )}
    </LayoutContainer>
  );
};
